 <style scoped style='stylus'>
.tab {
  height: 90px;
  background: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
}
.tab .title {
  display: inline-block;
  border-bottom: 3px solid transparent;
  padding: 17px 40px;
  /* line-height: 1.5; */
  cursor: pointer;
  transition: all 0.5s;
  background: #fff;
  padding-bottom: 0;
}
@media only screen and (min-width: 1266px) {
  .tab .title {
    display: inline-block;
    border-bottom: 3px solid transparent;
    padding: 17px 30px;
    /* line-height: 1.5; */
    cursor: pointer;
    transition: all 0.5s;
    background: #fff;
    padding-bottom: 0;
  }         
}
.title > p {
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 0;
}
.title > span {
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}
.tab .activeTit {
  background: rgba(233, 248, 255, 1);
  border-bottom: 3px solid #336db0;
}
.activeTit > p {
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(51, 109, 176, 1);
}
.activeTit > span {
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(51, 109, 176, 1);
}
.title i {
  float: right;
}
</style>
<template>
  <div class="tab">
    <div
      class="title"
      v-for="(item,index) in titleArr"
      :key="index"
      :class="{'activeTit':activeClass == index}"
      @click="changeTab(index)"
    >
      <span>{{item.title?item.title:'全国合计'}}</span>
      <p>{{format(item.value)}}辆</p>
      <br>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeClass: 0
    }
  },
  props: {
    titleArr: {
      type: Array,
      defalut: () => {
        return []
      }
    },
    path: {
      type: String,
      default: () => {}
    },
    dataType: {
      type: Number,
      default: () => {}
    },
    changeType: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {
    this.activeClass=this.dataType
  },
  methods: {
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    changeTab(index) {
      let that = this
      that.activeClass = index
      that.changeType(index)
    }
  }
}
</script>

